import { useEffect, useRef, useState } from 'react';

export function usePopup() {
  const [open, setOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (open) {
      const handler = () => {
        setOpen(false);
      };

      setTimeout(() => {
        document.addEventListener('click', handler);
      });
      return () => document.removeEventListener('click', handler);
    }
  }, [open, popupRef]);
  return { open, setOpen, popupRef };
}
